<template>
  <modal name="GroupsCreate" :width="500" height="auto" :scrollable="false" :adaptive="false" @closed="modalHide(false)">
    <div data-modal="group" class="panel mb-0">
      <div class="panel-hdr">
          <div class="w-100">
              <div class="row">
                  <div class="col-lg-12">
                      <h1 class="subheader-title mb-lg-0">
                          <i class="subheader-icon fal fa-window"></i> Создание категории
                      </h1>
                      <button type="button" class="close" @click="modalHide(false)">
                          <i class="fal fa-times"></i>
                      </button>
                  </div>
              </div>
          </div>
      </div>
      <div class="panel-container show">
          <div class="panel-content">
            <form data-form="create" @submit.prevent="groupCreate">
              <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <div class="form-group">
                        <label class="form-label">Название</label>
                        <input type="text" data-input="name" class="form-control" v-bind:class="{ 'is-invalid': 'name' in errors}" v-on:focus="$delete(errors, 'name')" v-model="name" v-focus>
                        <div class="invalid-feedback" v-if="'name' in errors">{{ errors['name'] }}</div>
                    </div>
                    <button data-button="create" class="btn btn-success">Продолжить</button>
                </div>
              </div>
            </form>
          </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    props: ['type'],
    name: 'GroupsCreate',
    data() {
      return {
        // Название категории
        'name': '',
        // Ошибки
        errors: {}
      }
    },
    methods: {
      // Обновление данных категории
      groupCreate ()
      {
        // Отправка запроса к API
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/groups/create', {name: this.name, type: this.type}).then(response => 
        {
          if(response.data.status == 'success')
            this.modalHide(true);
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      },
      // Показ модального окна
      modalShow() {
          this.$modal.show('GroupsCreate');
      },
      // Скрытие модального окна
      modalHide(groupsReload = false) {
          this.$emit('close', groupsReload);
      }
    },
    // Подгрузка данных
    mounted () 
    {
      this.modalShow();
    },
  }
</script>